import { OrderLogType } from "../../../enums/OrderLogType";

export class SaveOrderLogInput {
    orderId?: number;
    orderLogType: OrderLogType;
    userId?: number;
    details: string;
    parentId?: number|null;
}